<template>
    <div>
        <crumbTab :tabList="tabList" />
        <div class="report-list">
            <div v-for="(item, itemIndex) in meet.list" :key="item.title" class="list">
                <div class="title" @click="changeIndex(itemIndex)">
                    {{ item.title }}
                    <div class="icon" :class="{ active: index === itemIndex }"></div>
                </div>
                <div v-show="index === itemIndex" class="wrap">
                    <a target="_blank" :href="item.notice && item.notice.url"
                        ><div class="item notice">
                            业绩公告
                            <div class="down"></div>
                        </div>
                    </a>
                    <a target="_blank" :href="item.display && item.display.url">
                        <div class="item display">
                            业绩演示
                            <div class="down"></div></div
                    ></a>
                    <a target="_blank" :href="item.record && item.record.url">
                        <div class="item record">
                            活动记录
                            <div class="down"></div></div
                    ></a>
                    <a target="_blank" :href="item.picture && item.picture.url"
                        ><div class="item picture">
                            一图读懂
                            <div class="down"></div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import crumbTab from './components/crumb-tab.vue'
export default {
    name: 'ReportList',
    components: { crumbTab },
    data() {
        return {
            meet: {
                title: '',
                list: []
            },
            index: -1,
            tabList: [
                { content: '首页', url: '/cn/sc/prd/investor' },
                { content: '业绩推介', url: '/cn/sc/prd/investor/report' },
                { content: '投关活动', url: '/cn/sc/prd/investor/report-list' }
            ]
        }
    },
    async created() {
        this.index = this.$route.query.index !== undefined ? this.$route.query.index : -1
        await ajax.investorMeet().then(res => res && (this.meet = res))
        window.scrollTo({
            top: 0
        })
    },
    methods: {
        changeIndex(index) {
            if (this.index === index) {
                return (this.index = -1)
            }
            this.index = Number(index)
        }
    }
}
</script>

<style lang="scss" scoped>
.report-list {
    padding: 40px;
    .list {
        margin: 20px 0;
        .title {
            background: #fafafa;
            padding: 20px;
            font-size: 28px;
            font-weight: 500;
            color: #303030;
            position: relative;
            .icon {
                position: absolute;
                top: 50%;
                margin-top: -5px;
                width: 22px;
                height: 11px;
                right: 20px;
                background-image: url('~@/assets/images/investorRelation/arr-t.png');
                transform: rotate(180deg);
                background-size: 22px 11px;
                &.active {
                    transform: rotate(0deg);
                }
            }
        }
        .wrap {
            .down {
                width: 30px;
                height: 30px;
                position: absolute;
                right: 16px;
                background-repeat: no-repeat;
                background-size: 30px;
                background-image: url('~@/assets/images/investorRelation/dr.png');
                background-position: center;
                top: 50%;
                margin-top: -15px;
            }
            .item {
                padding: 25px 25px 25px 70px;
                background-repeat: no-repeat;
                background-size: 30px;
                background-position: 20px center;
                font-weight: 400;
                font-size: 26px;
                color: #303030;
                border-bottom: 1px solid #f0f0f0;
                position: relative;
                &:hover {
                    .down {
                        background-image: url('~@/assets/images/investorRelation/dr.png');
                    }
                }

                &.notice {
                    background-image: url('~@/assets/images/investorRelation/notice.png');
                }

                &.display {
                    background-image: url('~@/assets/images/investorRelation/display.png');
                }

                &.record {
                    background-image: url('~@/assets/images/investorRelation/record.png');
                }

                &.picture {
                    background-image: url('~@/assets/images/investorRelation/picture.png');
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/report-list.vue